import { MailDelivery } from 'todistukset-common/src/vtj/types/todistus'
import { finalEditableFieldValue } from 'todistukset-common/src/vtj/types/editable-field.type'

export const mailDeliveryFinalValues = (
  mailDelivery: MailDelivery
): {
  firstName: string
  lastName: string
  streetAddress: string
  streetAddressExtras: string
  postOffice: string
  postalCode: string
  country: string
} => {
  return {
    firstName: finalEditableFieldValue(mailDelivery.firstName) || '',
    lastName: finalEditableFieldValue(mailDelivery.lastName) || '',
    streetAddress: finalEditableFieldValue(mailDelivery.streetAddress) || '',
    streetAddressExtras:
      finalEditableFieldValue(mailDelivery.streetAddressExtras) || '',
    postOffice: finalEditableFieldValue(mailDelivery.postOffice) || '',
    postalCode: finalEditableFieldValue(mailDelivery.postalCode) || '',
    country: finalEditableFieldValue(mailDelivery.country) || '',
  }
}

export const mailDeliveryFields = [
  'firstName',
  'lastName',
  'streetAddress',
  'streetAddressExtras',
  'postalCode',
  'postOffice',
  'country',
] as const
